// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".photo[data-v-c4022fec]{padding-bottom:66.8656716418%}@media(min-width:768px){.photo[data-v-c4022fec]{padding-bottom:72.7272727273%}}.photo[data-v-c4022fec]:before{content:\"\";border-radius:.5rem;position:absolute;top:0;right:0;bottom:0;left:0;background:rgba(0,0,0,.4)}", ""]);
// Exports
module.exports = exports;
